<template>
  <div class="w-full my-4 flex gap-x-4 snap-mandatory snap-x overflow-x-scroll p-4 bg-primary-50">
    <div class="snap-start shrink-0" />
    <a
      v-for="image in images"
      :key="image.id"
      :href="image.url"
      target="_blank"
      class="snap-start shrink-0 group relative flex h-36 w-36 items-end justify-end overflow-hidden rounded-lg bg-gray-100 shadow-lg"
    >
      <img :src="image.url" loading="lazy" alt="Photo by Minh Pham" class="pointer-events-none absolute inset-0 h-full w-full object-cover object-center transition duration-200 group-hover:scale-110">
      <div class="pointer-events-none absolute inset-0 bg-gradient-to-t from-gray-800 via-transparent to-transparent opacity-50" />
      <button class="relative mr-3 mb-3 inline-block rounded-lg border border-primary-100 p-1 text-xs text-primary-200 backdrop-blur hover:text-primary-400" @click.stop.prevent="onDelete(image)">
        <TrashCanOutline class="h-6 w-6" aria-hidden="true" />
      </button>
    </a>
  </div>
</template>

<script setup>
import TrashCanOutline from 'vue-material-design-icons/TrashCanOutline.vue';
import { Modal } from '../composables/useModal';

const props = defineProps({
  images: {
    type: Array,
    default: () => []
  },
  noConfirm: {
    type: Boolean,
    default: false
  }
});

const emit = defineEmits([ 'delete' ]);

async function onDelete(image) {
  if (props.noConfirm) {
    emit('delete', image.id);
    return;
  }

  const confirm = await Modal.confirm({
    title: 'Delete Image',
    body: 'Are you sure you want to delete this image?',
    okButton: 'Delete',
    cancelButton: 'Cancel'
  });

  if (!confirm) {
    return;
  }

  emit('delete', image.id);
}
</script>
